import Vue from 'vue'
import {
  Button,
  Image,
  Tab,
  Tabs,
  List,
  Notify,
  Divider,
  Row,
  Col,
  Dialog,
  DatetimePicker,
  Field,
  CellGroup,
  ActionSheet,
  Cell,
  Popup,
  Picker,
  PullRefresh,
  Icon,
  Calendar,
  RadioGroup,
  Radio,
  Search,
  Toast,
  Rate,
  ImagePreview,
  Stepper,
  Checkbox,
  CheckboxGroup,
  Uploader,
  Skeleton,
  DropdownMenu,
  DropdownItem,
  NoticeBar,
  Swipe,
  SwipeItem,
  Card,
  Sticky,
  Tabbar,
  TabbarItem,
  Overlay,
  Loading,
  Switch,
  ShareSheet,
  Progress,
  Form,
  Sku,
  Area,
  Cascader,
  Tag,
  Steps,
  Step,
  Empty,
  Collapse,
  CollapseItem,
  Circle,
  SwipeCell
} from 'vant'

Vue
  .use(Button)
  .use(Image)
  .use(Tab)
  .use(Tabs)
  .use(List)
  .use(Notify)
  .use(Divider)
  .use(Row)
  .use(Col)
  .use(Dialog)
  .use(Field)
  .use(CellGroup)
  .use(Cell)
  .use(DatetimePicker)
  .use(Popup)
  .use(Picker)
  .use(PullRefresh)
  .use(Icon)
  .use(Calendar)
  .use(RadioGroup)
  .use(Radio)
  .use(Search)
  .use(ActionSheet)
  .use(Toast)
  .use(Rate)
  .use(ImagePreview)
  .use(Stepper)
  .use(Checkbox)
  .use(CheckboxGroup)
  .use(Uploader)
  .use(Skeleton)
  .use(DropdownMenu)
  .use(DropdownItem)
  .use(NoticeBar)
  .use(Swipe)
  .use(SwipeItem)
  .use(Card)
  .use(Sticky)
  .use(Tabbar)
  .use(TabbarItem)
  .use(Overlay)
  .use(Loading)
  .use(Switch)
  .use(ShareSheet)
  .use(Progress)
  .use(Form)
  .use(Sku)
  .use(Area)
  .use(Cascader)
  .use(Tag)
  .use(Steps)
  .use(Step)
  .use(Empty)
  .use(Collapse)
  .use(CollapseItem)
  .use(Circle)
  .use(SwipeCell)
